import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";

export default function NotFound() {
    const theme = useTheme();
    // init internationalization
    const {t} = useTranslation();
    return (
        <Grid
            id="not-found-container"
            container
            columnSpacing={4}
            sx={{padding: theme.spacing(8, 2)}}
        >
            <Grid sx={12}>
                <Typography variant="h3" gutterBottom>
                    {t("common.notFoundTitle")}
                </Typography>
                <Typography variant="body1">
                    {t("common.notFoundDescription")}
                </Typography>
            </Grid>
        </Grid>
    );
}
